import React from "react";
import WorkShopBasicInformation from "./WorkShopBasicInformation";
import WorkShopContactInformation from "./WorkShopContactInformation";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { stateToHTML } from "draft-js-export-html";
import HttpClient from "services/HttpClient";
import {
  VALIDATION_CONSTRAINST,
  MODULE_VALIDATION,
  QUESTION_CONSTRAINS,
  QUIZ_CONSTRAINS
} from "./constants";
import validate from "validate.js";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { inject } from "mobx-react";
import Modal from "react-modal";
import { observe } from "mobx";
const CREATE_WORKSHOP = "/api/v1/workshops";
const GET_WORKSHOP = "/api/v1/workshops/";
const DELETE_MODULE = "/api/v1/modules/";
const DELETE_QUESTION = "/api/v1/questions/";
const UPDATE_WORKSHOP = "/api/v1/workshops/";
@withRouter
@inject("publicWorkshopCreate")
@inject("alert")
@inject("preloader")
@inject("deleteModal")
@inject("user")
export default class CreatepublicWorkshopCreate extends React.Component {
  state = { modalOpened: false };

  componentDidMount = () => {
    this.routerListener = this.props.history.listen((location, action) => {
      this.props.publicWorkshopCreate.initialState();
    });
    if (this.props.match.params.id)
      new HttpClient()
        .get(GET_WORKSHOP + this.props.match.params.id)
        .then(data => {
          this.props.publicWorkshopCreate.setWorkshop(data.body.data.workshop);
          this.props.publicWorkshopCreate.setModules(data.body.data.workshop.modules);
          // this.setState({ modules: data.body.data.workshop.modules });
        });
    else this.props.publicWorkshopCreate.initialState();

    this.deleteObservable = observe(this.props.deleteModal, () => {
      if (this.props.deleteModal.deleteObject.type !== null) {
        this.setState({ modalOpened: true });
      }
    });
  };

  decline = () => {
    this.setState({ modalOpened: false });
  };

  deleteObject = () => {
    if (this.props.deleteModal.deleteObject.type === "module")
      new HttpClient()
        .delete(`${DELETE_MODULE}${this.props.deleteModal.deleteObject.id}`)
        .then(data => {
          this.setState({ modalOpened: false });
          this.props.publicWorkshopCreate.deleteModule(
            this.props.deleteModal.deleteObject.index
          );
          this.props.deleteModal.eventDelete({ type: null });
          this.props.alert.success("Successfully deleted ");
        })
        .catch(data => this.props.alert.error("Something went wrong"));
    if (this.props.deleteModal.deleteObject.type === "question")
      new HttpClient()
        .delete(`${DELETE_QUESTION}${this.props.deleteModal.deleteObject.id}`)
        .then(() => {
          this.setState({ modalOpened: false });
          this.props.publicWorkshopCreate.deleteQuestion(
            this.props.deleteModal.deleteObject.moduleId,
            this.props.deleteModal.deleteObject.index
          );
          this.props.alert.success("Successfully deleted ");
        })
        .catch(() => this.props.alert.error("Something went wrong"));

    if (this.props.deleteModal.deleteObject.type === "file") {
      this.handleDeleteFile();
    }
  };

  handleDeleteFile = () => {
    switch (this.props.deleteModal.deleteObject.fileTo) {
      case "workshop":
        this.removeMoreInfo();
        break;
      case "module":
        this.removeModuleFile();
        break;
      case "question":
        this.removeQuestionFile();
    }
  };

  removeQuestionFile = () => {
    let deleteObject = this.props.deleteModal.deleteObject;
    let module = this.props.publicWorkshopCreate.modules[deleteObject.modal];
    let question = module.questions_attributes[deleteObject.question];
    let fileID = deleteObject.fileId;
    new HttpClient()
      .put(UPDATE_WORKSHOP + this.props.publicWorkshopCreate.workshop.id, {
        id: this.props.publicWorkshopCreate.workshop.id,
        modules_attributes: [
          {
            id: module.id,
            questions_attributes: [
              {
                id: question.id,
                attachments_attributes: [{ id: fileID, _destroy: true }]
              }
            ]
          }
        ]
      })
      .then(() => {
        this.setState({ modalOpened: false });
        this.props.deleteModal.eventDelete({ type: null });
        this.props.alert.success("Successfully deleted ");
        this.props.publicWorkshopCreate.deleteQuestionFile(
          deleteObject.modal,
          deleteObject.question,
          deleteObject.file
        );
      })
      .catch(() => this.props.alert.error("Something went wrong"));
  };

  removeModuleFile = () => {
    let deleteObject = this.props.deleteModal.deleteObject;
    let moduleId = this.props.publicWorkshopCreate.modules[deleteObject.module].id;
    let fileID = deleteObject.fileId;
    new HttpClient()
      .put(UPDATE_WORKSHOP + this.props.publicWorkshopCreate.workshop.id, {
        modules_attributes: [
          {
            id: moduleId,
            attachments_attributes: [{ id: fileID, _destroy: true }]
          }
        ]
      })
      .then(data => {
        this.setState({ modalOpened: false });
        this.props.alert.success("Successfully deleted");
        this.props.publicWorkshopCreate.deleteModuleFile(
          deleteObject.module,
          deleteObject.fileIndex
        );
      })
      .catch(() => this.props.alert.error("Something went wrong"));
  };

  removeMoreInfo = () => {
    new HttpClient()
      .put(UPDATE_WORKSHOP + this.props.publicWorkshopCreate.workshop.id, {
        more_info: null
      })
      .then(data => {
        this.setState({ modalOpened: false });
        this.props.deleteModal.eventDelete({ type: null });
        this.props.alert.success("Successfully deleted ");
        this.props.publicWorkshopCreate.deleteFile();
      })
      .catch(() => {
        this.props.alert.success("Something went wrong");
      });
  };

  submitHandler = () => {
    const workshop = this.props.publicWorkshopCreate.getWorkShop();
    const modules = this.props.publicWorkshopCreate.modules;
    const options = {
      entityStyleFn: entity => {
        if (entity.get("type").toLowerCase() === "link") {
          const data = entity.getData();

          return {
            element: "a",
            attributes: {
              href: data.url,
              target: data.targetOption || data.target
            }
          };
        }
      }
    };

    const filteredModules = this.props.publicWorkshopCreate.modules ? this.props.publicWorkshopCreate.modules.filter(module => module.details) : [];
    let data = _.assign({}, this.props.publicWorkshopCreate.getWorkShop(), {
      modules_attributes: filteredModules,
    });
    let formData = new FormData();
    if (!data.fee) {
      data.cost = null;
      formData.append("fee", 0);
      formData.append("cost", 0);
    }
    if (!data.cpd_hours) {
      data.how_many_hours = null;
      formData.append("how_many_hours", 0);
      formData.append("cpd_hours", 0);
    }
    if (!data.deleteThisIds) {
      formData.append("deleted_question_ids", null);
    }

    if (data.deleteThisIds) {
      data.deleteThisIds.forEach(id => {
        formData.append("deleted_question_ids[]", id);
      });
    }

    // if (this.props.publicWorkshopCreate.getWorkShop().description !== "") {
    //   // let desc1 = draftToHtml(convertToRaw(this.props.publicWorkshopCreate.getWorkShop().description.getCurrentContent()));

    //   // let descrioption = stateToHTML(
    //   //   this.props.publicWorkshopCreate.getWorkShop().description.getCurrentContent(),
    //   //   options
    //   // );

    //   // data.description = descrioption
    //   //   .replace("<figure>", "")
    //   //   .replace("</figure", "");


    //   let descrioption = this.props.publicWorkshopCreate.getWorkShop().description;
    //   data.description = descrioption;
    //   if (data.description.trim() === "<p></p>") data.description = null;
    // }
    data = _.mapValues(data, value => (value === "" ? null : value));
    let errors = validate(data, VALIDATION_CONSTRAINST);
    this.props.publicWorkshopCreate.validateCouponCode();
    let newCaption;
    if (data.description) {
      newCaption = document.createElement("div");
      newCaption.innerHTML = data.description.trim();
      newCaption = newCaption.textContent;
    }

    let descriptionErrors = validate.single(
      newCaption ? newCaption.replace(/\s/g, "") : null,
      {
        presence: { message: "Description is required" },
        length: {
          maximum: 5000,
          tooLong: "Only 5,000 characters are allowed for the Description field"
        }
      },
      { fullMessages: false }
    );
    if (descriptionErrors)
      errors = _.assign(errors, { description: descriptionErrors });
    _.mapValues(errors, v => {
      let res = "";
      for (let i = 0; i < v.length; i++) res += `${v[i]}`;
      this.props.alert.error(res);
    });

    formData.append("provider_bio", "");
    _.mapKeys(data, (value, key) => {
      if (value instanceof Array || key === "description") return;
      if (key === 'visibility') {
        formData.append(key, value);
      }
      if (!!value) if (key !== "more_info") formData.append(key, value);
    });
    if (data.more_info !== 1 && data.more_info !== null)
      formData.set("more_info", data.more_info);
    data.description = this.addFileToDescription(
      data.description,
      "description"
    );

    if (data.description.description !== null) {
      formData.append("description[]description", data.description.description);
      data.description.documents.forEach(el => {
        if (data.description.description.includes(el.src)) {
          formData.append("description[]documents[]file", el.file);
          formData.append("description[]documents[]src", el.src);
        }
      });
    }

    let hasErrors = false;
    this.props.publicWorkshopCreate.clearModuleError();

    if (data.target_audience) {
      data.target_audience.forEach(target => {
        formData.append("target_audience[]", target.value);
      });
    }

    if (data.modules_attributes)
      data.modules_attributes.forEach((el, index) => {
        let questionIndex = index;
        el = _.assign({}, el);
        if (el.details && el.details !== "") {
          // let details = stateToHTML(el.details.getCurrentContent(), options);
          // el.details = details.replace("<figure>", "").replace("</figure>", "");
          // if (el.details.trim() === "<p></p>") el.details = null;

          if (el.details.trim() === "<p></p>") el.details = null;
        }
        let moduleValidationObject = _.assign({}, el);
        if (moduleValidationObject.details) {
          let description = moduleValidationObject.details
            .trim()
            .replace(/\s/g, "");
          if (description !== "") {
            newCaption = document.createElement("div");
            newCaption.innerHTML = description;
            newCaption = newCaption.textContent;
            moduleValidationObject.details = newCaption.replace(/\s/g, "");
          }
        }
        let moduleErrors = validate(moduleValidationObject, MODULE_VALIDATION, {
          fullMessages: false
        });

        _.mapValues(moduleErrors, v => {
          let res = "";
          for (let i = 0; i < v.length; i++) res += `${v[i]}`;
          this.props.alert.error(res);
        });

        if (moduleErrors) hasErrors = true;
        this.props.publicWorkshopCreate.addModuleError(moduleErrors);
        let prefix = "modules_attributes";
        _.mapKeys(el, (value, key) => {
          if (key === "attachments_attributes") {
            let attachmentPrefix = "modules_attributes[]attachments_attributes";
            el.attachments_attributes.forEach(element => {
              _.mapKeys(element, (value, key) => {
                if (!!value && element.id === undefined) {
                  formData.append(attachmentPrefix + "[]" + key, value);
                }
              });
            }); 
          }

          if (key === "questions_attributes") {
            if (el.module_type === "quiz" && !value.length) { 
              hasErrors = true;
              this.props.alert.error("Module with quiz can't be empty.");
            }

            let questionPrefix = "modules_attributes[]questions_attributes";
            el.questions_attributes.forEach((question, index) => {
              question = _.assign({}, question);

              // if (question.text !== "" && el.module_type != "quiz") {
              //   // let text = stateToHTML(
              //   //   question.text.getCurrentContent(),
              //   //   options
              //   // );
              //   // question.text = text
              //   //   .replace("<figure>", "")
              //   //   .replace("</figure>", "");
              //   // question.text = draftToHtml(convertToRaw(question.text.getCurrentContent()));
              //   if (question.text.trim() === "<p></p>") question.text = null;
              // }

              let moduleErrors;
              if (el.module_type === "quiz") {
                moduleErrors = validate(question, QUIZ_CONSTRAINS, {
                  fullMessages: false
                });
              } else {
                moduleErrors = validate(question, QUESTION_CONSTRAINS, {
                  fullMessages: false
                });
              }

              _.mapValues(moduleErrors, v => {
                let res = "";
                for (let i = 0; i < v.length; i++) res += `${v[i]}`;
                if (el.module_type === "quiz") {
                  const title = el.title || (questionIndex + 1);
                  this.props.alert.error(
                    res +
                      title +
                      " (question " +
                      (index + 1) +
                      ")"
                  );
                } else {
                  this.props.alert.error(res);
                }
              });
              if (moduleErrors) {
                hasErrors = true;
                this.props.publicWorkshopCreate.addQuestionError(
                  questionIndex,
                  moduleErrors
                );
              } else {
                this.props.publicWorkshopCreate.removeQuestionError(
                  questionIndex,
                  index
                );
              }
              formData.append(questionPrefix + "[]separator", "someseparator");
              _.mapKeys(question, (value, key) => {
                if (key === "attachments_attributes") {
                  let questionAttachmentPrefix =
                    "modules_attributes[]questions_attributes[]attachments_attributes";
                  value.forEach((el, index) => {
                    let attachments = el;
                    _.mapKeys(el, (value, key) => {
                      if (attachments.id === undefined)
                        formData.append(
                          questionAttachmentPrefix + "[]" + key,
                          value
                        );
                    });
                  });
                } else if ((this.props.publicWorkshopCreate.workshop.id && key === 'correct') || !!value) {
                  if (key === "text") {
                    value = _.assign({}, { text: value, documents: [] });
                    formData.append(
                      questionPrefix + "[]text[]text",
                      value.text
                    );
                    if (
                      this.props.publicWorkshopCreate.questionsMap.has(
                        `${questionIndex}${index}`
                      )
                    ) {
                      this.props.publicWorkshopCreate.questionsMap
                        .get(`${questionIndex}${index}`)
                        .files.forEach(el => {
                          if (value.text.includes(el.src)) {
                            formData.append(
                              questionPrefix + "[]" + "text[]documents[]src",
                              el.src
                            );
                            formData.append(
                              questionPrefix + "[]" + "text[]documents[]file",
                              el.file
                            );
                          }
                        });
                    }
                  } else formData.append(questionPrefix + "[]" + key, value);
                }
              });
            });
          }
          if (value instanceof Array) return;
          if (!!value) {
            if (key === "details") {
              if (
                this.props.publicWorkshopCreate.modulesDetailsMap.has(questionIndex)
              ) {
                formData.append(prefix + "[]" + "details[]details", value);
                let files = this.props.publicWorkshopCreate.modulesDetailsMap.get(
                  questionIndex
                ).files;
                value = _.assign({}, { details: value }, { documents: files });
                files.forEach(el => {
                  if (value.details.includes(el.src)) {
                    formData.append(
                      prefix + "[]" + "details[]documents[]src",
                      el.src
                    );
                    formData.append(
                      prefix + "[]" + "details[]documents[]file",
                      el.file
                    );
                  }
                });
              } else {
                console.warn("VALUE", value);
                // if(value.includes('<img')){
                //   console.log('value includes img tag');
                //   let str = value.replace(/<img[^>]*>/g,"");
                //   console.warn('REPLACED VALUE', str);
                //   formData.append(prefix + '[]' + 'details[]details',str )
                // }
                formData.append(prefix + "[]" + "details[]details", value);
              }
            } else {
              formData.append(prefix + "[]" + key, value);
            }
          } else if(key === 'is_hidden' && !value) {
            formData.append(prefix + "[]" + key, value);
          }
        });
      });
    this.addCouponsToFormData(formData);
    let feeError = {};
    let hourError = {};
    if (data.fee && data.cost === null)
      feeError = { cost: ["Cost must ne exist"] };
    if (data.cpd_hours && data.how_many_hours === null)
      hourError = { how_many_hours: ["Hours must ne exist"] };
    let newErrors = _.assign({}, errors, feeError, hourError);
    if (data.target_audience.slice().length === 0) {
      newErrors = _.assign({}, newErrors, {
        target_audience: "Suitable for is required"
      });
    }
    this.props.publicWorkshopCreate.setErrors(newErrors);
    if (
      _.isEmpty(newErrors) &&
      !hasErrors &&
      !this.props.publicWorkshopCreate.couponHasErrors()
    ) {
      this.setState({ errors: {} });
      this.props.preloader.activatePreloader();


      // for (var pair of formData.entries()) {
      //     console.log(pair[0]+ ', ' + pair[1]); 
      // } 


      if (this.props.publicWorkshopCreate.workshop.id)
        new HttpClient()
          .multipart(
            UPDATE_WORKSHOP + this.props.publicWorkshopCreate.workshop.id,
            formData,
            "PUT"
          )
          .then(data => {
            this.props.preloader.disablePrelaoder();
            if (!data.error) {
              if (
                this.props.publicWorkshopCreate.workshop.workshop_state ===
                "confirmed_workshop" && !data
              ) {
                this.props.alert.info("A True or False option needs to be chosen for each question in the quiz", 10000);
              } 
              else if (this.props.publicWorkshopCreate.workshop.workshop_state ===
                "confirmed_workshop" && this.props.publicWorkshopCreate.workshop.add_modules) {
                this.props.alert.success(
                  "Your workshop has been successfully updated.",
                  10000
                );
              } else {
                this.props.alert.success(
                  "Your workshop info has been successfully updated.",
                  10000
                );
              }
              if(this.props.publicWorkshopCreate.workshop.created_by !== this.props.user.getUser().id && this.props.user.getUser().role === 'admin') {
                this.props.history.push(
                  "/admin/details/" + data.body.data.workshop.id
                );
              } else {
                this.props.history.push(
                  "/provider/my_public_workshops/" + data.body.data.workshop.id
                );
              }
            }
            else if (data.error) {
              this.props.alert.info("Discount code already used. Please choose a different one.");
              console.log('error! ', data);

              if (data.error && data.error.errors['coupons.code']) {
                let newCodesErr = [];
                this.props.publicWorkshopCreate.workshop.coupons_attributes.forEach(el => {
                  newCodesErr.push({code: ['Discount code already used.'], id: el.id});
                })
                this.props.publicWorkshopCreate.setCouponError(newCodesErr);
              }
            }
          })
          .catch(err => {
            // this.props.alert.info("Workshop invalid");
            this.props.preloader.disablePrelaoder();

            // let newErrors = _.assign({}, this.props.publicWorkshopCreate.errors, {
            //   title: ["Title has alredy used"]
            // });
            // this.props.publicWorkshopCreate.addErrors(newErrors);
          });
      else
        new HttpClient()
          .multipart(CREATE_WORKSHOP, formData, "POST")
          .then(data => {
            this.props.preloader.disablePrelaoder();
            if (this.props.user.getUser().role !== "admin")
              this.props.user.setUserCoach();
            this.props.alert.success(
              "Thanks for submitting the Workshop info. " +
                "It is currently being reviewed by the Therapy Academy team. If approved, " +
                "we will be in touch in due course.",
              10000
            );
            this.props.history.push(
              "/provider/my_workshop/" + data.body.data.workshop.id
            );
          })
          .catch(err => {
            this.props.alert.info("Workshop invalid");
            this.props.preloader.disablePrelaoder();
            let newErrors = _.assign({}, this.props.publicWorkshopCreate.errors, {
              title: ["Title has alredy used"]
            });
            this.props.publicWorkshopCreate.addErrors(newErrors);
          });
    }
  };

  addFileToDescription = (data, key) => {
    return _.assign(
      {},
      { [key]: data },
      { documents: this.props.publicWorkshopCreate.moduleDescriptionFile }
    );
  };

  handleChange = data => {
    this.props.publicWorkshopCreate.handleChange(data);
  };

  updateMoreInfo = e => {
    e.preventDefault();
    this.props.publicWorkshopCreate.updateMoreInfo(e);
  };

  deleteFile = () => {
    this.props.publicWorkshopCreate.deleteFile();
  };

  componentWillUnmount = () => {
    this.props.publicWorkshopCreate.initialState();
    this.routerListener();
    this.deleteObservable();
  };

  addCouponsToFormData(formData) {
    const coupons = this.props.publicWorkshopCreate.workshop.coupons_attributes;
    coupons.forEach(el => {
      formData.append("coupons_attributes[]code", el.code);
      if (el.is_free)
        formData.append("coupons_attributes[]is_free", el.is_free);
      if (!el.cost.split(".")[1])
        formData.append("coupons_attributes[]cost", el.is_free ? 0 : el.cost.split(".")[0]);
      else formData.append("coupons_attributes[]cost", el.is_free ? 0 : el.cost);
      formData.append("coupons_attributes[]expiry_date", el.expiry_date);
      if (el._destroy) {
        formData.append("coupons_attributes[]_destroy", true);
      }
      if (el.id && !el.isNew) formData.append("coupons_attributes[]id", el.id);
    });
  }

  render() {
    return (
      <main className="main-content">
        <Modal
          isOpen={this.state.modalOpened}
          closeTimeoutMS={100}
          contentLabel="Modal"
        >
          <h1>Do you want delete it?</h1>
          <div className="modal-permissions-button">
            <div className="workshop-creator-sidebar-publish">
              <span className="btn prime bordered" onClick={this.deleteObject}>
                Accept
              </span>
            </div>
            <div
              className="workshop-creator-sidebar-publish"
              style={{ marginLeft: 15 }}
            >
              <span className="btn prime bordered red" onClick={this.decline}>
                Decline
              </span>
            </div>
          </div>
        </Modal>
        <div className="container-fluid">
          <div className="row regular-workshop workshop-creator custom-styles-workshop">
            <WorkShopContactInformation
              handleChange={this.handleChange}
              handleSubmit={this.submitHandler}
            />

            <WorkShopBasicInformation
              updateMoreInfo={this.updateMoreInfo}
              handleChange={this.handleChange}
              deleteFile={this.deleteFile}
            />
          </div>
        </div>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/create_public_workshop/CreatePublickWorkShop.jsx